// project-imports
import AgencyLibrarySettings from './AgencyLibrarySettings';
import assessmentDetails from './AssessmentDetails';
import Assessors from './Assessors';
import Batches from './Batches';
import dashboard from './dashboard';
import QuestionBank from './QuestionBank';
import PerformanceEvaluation from './PerformanceEvaluation';
import Result from './Result';
import Rubrics from './Rubrics';
import Tickets from './Tickets';

// types
import { NavItemType } from 'types/menu';

// ==============================|| MENU ITEMS ||============================== //

const menuItems: { items: NavItemType[] } = {
  items: [
    dashboard,
    Assessors,
    Batches,
    AgencyLibrarySettings,
    assessmentDetails,
    Rubrics,
    QuestionBank,
    PerformanceEvaluation,
    Result,
    Tickets
  ]
};

export default menuItems;
